import { cn } from '@/lib/utils'
import logoMark from '@/assets/logo-mark-v3.png'
import logoWordmark from '@/assets/logo-wordmark.png'

interface CoworkLogoProps {
  className?: string
  iconOnly?: boolean
}

// โลโก้ JosCoWork (ไอคอนหนังสือ+กระเป๋า + wordmark) แยกเป็น component กลางเพื่อใช้ซ้ำในหน้า Login/Register/VerifyEmail
// ให้ภาพเดียวกันทุกที่ — wordmark ชุดเดียวกับหน้าโหลดและ Navbar
export function CoworkLogo({ className, iconOnly = false }: CoworkLogoProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <img src={logoMark} alt="Jos CoWork" className="h-11 w-auto shrink-0 object-contain" />
      {!iconOnly && <img src={logoWordmark} alt="" aria-hidden="true" className="h-5 w-auto shrink-0 object-contain" />}
    </div>
  )
}
